import {
    Box,
    Button,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const CourseThankYou = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const courseId = location.state?.courseId;

    useEffect(() => {
        if (!courseId) {
            navigate("/codegenie/generated-courses");
        }
    }, [courseId, navigate]);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#0d1117",
                p: 3,
            }}
        >
            <Paper
                elevation={4}
                sx={{
                    width: "100%",
                    maxWidth: 650,
                    p: 5,
                    borderRadius: 4,
                    textAlign: "center",
                    background: "#161b22",
                    color: "#fff",
                }}
            >
                <CheckCircleRoundedIcon
                    sx={{
                        fontSize: 90,
                        color: "#22c55e",
                        mb: 2,
                    }}
                />

                <Typography
                    variant="h4"
                    fontWeight={700}
                    gutterBottom
                >
                    Enrollment Successful!
                </Typography>

                <Typography
                    sx={{
                        color: "#9ca3af",
                        mb: 4,
                        fontSize: 16,
                    }}
                >
                    Thank you for purchasing the course.
                    <br />
                    Your payment has been confirmed and the course has been added to your account.
                </Typography>

                <Stack
                    spacing={2}
                    sx={{
                        mb: 4,
                        textAlign: "left",
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <SchoolRoundedIcon color="success" />
                        <Typography>
                            Your enrollment is confirmed.
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2}>
                        <SchoolRoundedIcon color="success" />
                        <Typography>
                            You can access this course anytime.
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2}>
                        <SchoolRoundedIcon color="success" />
                        <Typography>
                            Start learning immediately.
                        </Typography>
                    </Stack>
                </Stack>

                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    justifyContent="center"
                >
                    <Button
                        variant="contained"
                        startIcon={<MenuBookRoundedIcon />}
                        sx={{
                            px: 4,
                            py: 1.2,
                            textTransform: "none",
                        }}
                        onClick={() =>
                            navigate("/codegenie/course-detail", {
                                state: {
                                    courseId,
                                },
                            })
                        }
                    >
                        Start Learning
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{
                            px: 4,
                            py: 1.2,
                            textTransform: "none",
                        }}
                        onClick={() =>
                            navigate("/codegenie/generated-courses")
                        }
                    >
                        My Courses
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
};

export default CourseThankYou;